import { Component, OnInit, Renderer2 } from '@angular/core';

import { ADRUM, TEALIUM, environment } from '../../../environments/environment';

@Component({
    selector: 'script-injector-component',
    template: ``,
    standalone: false
})
export class ScriptInjectorComponent implements OnInit {
  constructor(private readonly _renderer: Renderer2) { }

  ngOnInit(): void {
    this.loadTealium();
    this.loadAdrumConfigScript();
    this.loadAdrumScript();
  }

  private loadTealium() {
    const tealiumEnv = environment?.envName?.includes('prod') ? 'prod': 'qa';
    const tealiumScriptUrl =
      TEALIUM.SCRIPT_URL.replace(TEALIUM.PLACEHOLDER_BRAND_CODE, TEALIUM.BRAND_CODE).replace(TEALIUM.PLACEHOLDER_ENV, tealiumEnv);
    this.loadScript(tealiumScriptUrl);
  }

  private loadScript(src: string) {
    const newScript = this._renderer.createElement('script');
		newScript.type = "text/javascript";
		newScript.async = true;
		newScript.src = src;
		this._renderer.appendChild(document.body, newScript);
  }

  private loadAdrumConfigScript(): void {
    const newScript = this._renderer.createElement('script');
    newScript.type = 'text/javascript';
    newScript.charset = 'UTF-8';
    newScript.innerHTML = `
      window["adrum-start-time"] = new Date().getTime();
      (function(config){
        config.appKey = "${ADRUM.APP_KEY}";
        config.adrumExtUrlHttp = "http://cdn.appdynamics.com";
        config.adrumExtUrlHttps = "https://cdn.appdynamics.com";
        config.beaconUrlHttp = "http://pdx-col.eum-appdynamics.com";
        config.beaconUrlHttps = "https://pdx-col.eum-appdynamics.com";
        config.useHTTPSAlways = true;
        config.resTiming = { "bufSize": 200, "clearResTimingOnBeaconSend": true };
        config.maxUrlLength = 512;
        config.spa = { "spa2": true };
        config.isZonePromise = true;
        config.angular = true;
      })(window["adrum-config"] || (window["adrum-config"] = {}));
    `;
    this._renderer.appendChild(document.head, newScript);
  }

  private loadAdrumScript(): void {
    const newScript = this._renderer.createElement('script');
    newScript.src = '//cdn.appdynamics.com/adrum/adrum-latest.js';
    this._renderer.appendChild(document.head, newScript);
  }
}
